import { Property as Domain, PropertyField } from 'modules/cm/RepaymentStrategy/RepaymentStrategy';
import { format } from 'utils/date';
import { Property as API } from '../Property';

const apiToDomain = (api: API): Domain => ({
  [PropertyField.Id]: api.id,
  [PropertyField.City]: api.city,
  [PropertyField.County]: api.county,
  [PropertyField.FlatNumber]: api.flatNumber,
  [PropertyField.BuildingNumber]: api.buildingNumber,
  [PropertyField.BuildingName]: api.buildingName,
  [PropertyField.Street]: api.street,
  [PropertyField.PostCode]: api.postcode,
  [PropertyField.DateOfPurchase]: api.dateOfPurchase ? format(api.dateOfPurchase).fromBackendToView() : null,
  [PropertyField.CurrentMortgageBalance]: api.currentMortgageBalance,
  [PropertyField.PurchasePrice]: api.purchasePrice,
});

export default apiToDomain;
